export default [
	{
		path: "/procon",
		name: "Kurier Procon",
		component: () => import("@/layouts/LayoutProcon.vue"),
		meta: {
			description: "Kurier Procon",
			requiresAuth: true,
			info: "produto",
			requiresPermission: "produtos",
		},
		children: [
			{
				path: "/procon/central-reclamaces",
				name: "centralReclamacoes",
				component: () =>
					import("@/views/procon/CentralReclamacoesView.vue"),
				meta: {
					description: "CENTRAL RECLAMACOES",
					requiresAuth: true,
					tituloMenu: "Kurier Procon",
				},
			},
			{
				path: "/procon/integracoes",
				name: "integracoesProcon",
				component: () =>
					import("@/views/procon/IntegracoesProconView.vue"),
				meta: {
					description: "INTEGRACOES PROCON",
					requiresAuth: true,
					tituloMenu: "Kurier Procon",
				},
			},
			{
				path: "/procon/painel-inteligencia",
				name: "painelInteligencia",
				component: () =>
					import("@/views/procon/PainelInteligenciaView.vue"),
				meta: {
					description: "PAINEL INTELIGENCIA",
					requiresAuth: true,
					tituloMenu: "Kurier Procon",
				},
			},
		],
	},
];
